import { PublicKey, TransactionInstruction } from "@solana/web3.js";
import { ReferralProgram } from "../type";
import { deriveEscrow } from "../pda";

export interface IInitializeEscrowParams {
  referralProgram: ReferralProgram;
  stakingAddress: PublicKey;
  owner: PublicKey;
  payer: PublicKey;
}

export async function createInitializeEscrowIx(
  params: IInitializeEscrowParams,
): Promise<TransactionInstruction> {
  const { referralProgram, stakingAddress, owner, payer } = params;

  const escrow = deriveEscrow(stakingAddress, owner, referralProgram.programId);

  return referralProgram.methods
    .initializeEscrow()
    .accountsPartial({
      staking: stakingAddress,
      escrow,
      owner,
      payer,
    })
    .instruction();
}
